import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../data/site";

export function MobileCTA() {
  return (
    <div className="mobile-cta" data-testid="mobile-cta-bar">
      <div className="mobile-cta-inner">
        <a href={CONTACT.phoneHref} className="m-call" data-testid="mobile-cta-call"><Phone size={18} /> Call</a>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="m-wa" data-testid="mobile-cta-whatsapp"><MessageCircle size={18} /> WhatsApp</a>
        <Link to="/contact" className="m-quote" data-testid="mobile-cta-quote">Get Quote</Link>
      </div>
    </div>
  );
}

export function QuoteCTA({ title = "Need a Storage Solution?", text = "Tell us about your warehouse, storage requirement or existing system." }) {
  return (
    <section className="cta-band" data-testid="quote-cta-band">
      <div className="container cta-inner">
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="cta-btns">
          <Link to="/contact" className="btn btn-orange" data-testid="cta-quote-btn">Get a Quote <ArrowRight size={16} /></Link>
          <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="btn btn-whatsapp" data-testid="cta-whatsapp-btn"><MessageCircle size={16} /> WhatsApp Us</a>
        </div>
      </div>
    </section>
  );
}
